// angular imports
import {
    Component,
    EventEmitter,
    Injector,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';

// cc-common imports
import { Utils } from 'cc-common';

// devextreme imports
import { DxDataGridComponent } from 'devextreme-angular';

// component imports
import { WorkOrderBaseComponent } from '../../../_base/work-order-base-component';

// service imports
import { WorkflowSharedService } from '../../../../shared-workflow-module/_services/workflow-shared.service';

// model imports
import { WorkFlowWorkOrderLinkResultDto } from '../../../_models/workflow-work-order-link-result-dto';
import { WorkFlowParametersDto } from '../../../../shared-workflow-module/_models/workflow-parameters-dto';

@Component({
    selector: 'app-manage-invoice-grid',
    templateUrl: './manage-invoice-grid.component.html',
    styleUrls: ['./manage-invoice-grid.component.scss']
})
export class ManageInvoiceGridComponent extends WorkOrderBaseComponent implements OnInit, OnChanges {
    @ViewChild('invoiceGrid', { static: false }) invoiceGrid: DxDataGridComponent;

    @Input() workOrderStatus: string;
    @Input() invoiceGridSource: Array<WorkFlowWorkOrderLinkResultDto> = [];
    @Input() invoiceIds: Array<number> = [];
    @Input() communityId: number;

    @Output() onRowSelectionChange = new EventEmitter<any>();

    storageKey: string;
    selectedWFWorkOrder: WorkFlowWorkOrderLinkResultDto;
    showWorkflowViewer = false;

    constructor(protected readonly injector: Injector, private readonly workflowSharedService: WorkflowSharedService) {
        super(injector);
    }

    ngOnInit() {
        this.storageKey = `${this.workOrderStatus.toUpperCase()}_WORKORDER_INVOICES`;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (Utils.notNullOrEmpty(changes.invoiceGridSource) && changes.invoiceGridSource.currentValue) {
            this.invoiceGridSource = changes.invoiceGridSource.currentValue;
            this.prepareInvoiceGridSource();
        }
    }

    onGridContentReady(event: any): void {
        if (Utils.notNullOrEmpty(this.invoiceIds)) {
            event.component.selectRows(this.invoiceIds, true);
            this.applySorting();
        }
    }

    onGridSelectionChanged(event: any): void {
        const selectedRowKeys = event.selectedRowKeys;
        const deSelectedRowKeys = event.currentDeselectedRowKeys;

        this.onRowSelectionChange.emit({
            selectedRowKeys,
            deSelectedRowKeys
        });
    }

    onInvoiceClick(record: WorkFlowWorkOrderLinkResultDto): void {
        const baseParams: WorkFlowParametersDto = new WorkFlowParametersDto();
        baseParams.workflowId = record.workFlowId;
        baseParams.communityId = this.communityId;

        this.workOrderHelperService.showLoading();
        this.workflowSharedService.downloadInvoice(baseParams).subscribe(
            (result: Blob) => {
                if (Utils.notNullOrEmpty(result)) {
                    const fileURL: string = this.helperService.getFileUrlFromBlob(result);
                    window.open(fileURL, '_blank', 'location=yes,height=670,width=620,scrollbars=yes,status=yes');
                }
                this.workOrderHelperService.hideLoading();
            },
            (error) => {
                this.errorService.displayError(error);
                this.workOrderHelperService.hideLoading();
            }
        );
    }

    onWorkFlowClick(record: WorkFlowWorkOrderLinkResultDto): void {
        this.selectedWFWorkOrder = record;
        this.showWorkflowViewer = true;
    }

    onWorkflowViewerClose(): void {
        this.showWorkflowViewer = false;
    }

    private prepareInvoiceGridSource(): void {
        if (Utils.notNullOrEmpty(this.invoiceIds)) {
            this.invoiceGridSource.forEach((row) => {
                row.sortId = this.invoiceIds.find((d) => Utils.equals(d, row.workFlowId)) ? 1 : 0;
            });
        }
    }

    private applySorting(): void {
        this.invoiceGridSource.sort((ele1, ele2) => {
            if (ele1.sortId < ele2.sortId) {
                return 1;
            } else if (ele1.sortId > ele2.sortId) {
                return -1;
            } else {
                return 0;
            }
        });
        this.invoiceGrid.instance.option('dataSource', this.invoiceGridSource);
        this.invoiceGrid.instance.refresh(true);
    }
}
